"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTableRow = void 0;
const debug_1 = __importDefault(require("debug"));
const vue_1 = __importDefault(require("vue"));
const constants = __importStar(require("./constants"));
const vue_property_decorator_1 = require("vue-property-decorator");
const cell_1 = require("./cell");
const row_edit_commands_1 = require("./row-edit-commands");
const row_header_1 = require("./row-header");
const row_menu_1 = require("./row-menu");
const row_selector_1 = require("./row-selector");
const row_model_1 = require("./model/row-model");
const log = (0, debug_1.default)('itp:ui:components:datatable:row');
let ItpDataTableRow = class ItpDataTableRow extends vue_1.default {
    model;
    onFocusCell;
    row;
    columns;
    noTableEdit;
    editable;
    editing;
    noDelete;
    rowDetailsToggle;
    onEditingChanged(editing) {
        if (editing) {
            this.$nextTick(() => this.focusCellEditor());
        }
    }
    get validationState() {
        return this.row.validationState;
    }
    get invalid() {
        return this.validationState && this.validationState.invalid;
    }
    get validated() {
        return this.validationState && this.validationState.validated;
    }
    get saving() {
        return this.row.isSaving;
    }
    get deleting() {
        return this.row.isDeleting;
    }
    mounted() {
        if (this.editing) {
            this.$nextTick(() => this.focusCellEditor());
        }
        this.onFocusCell = (args) => {
            if (args.stop || this.row.rowKey != args.row) {
                return;
            }
            this.focusCellEditor(args.fieldName);
            args.stop = true;
        };
        this.model.eventBus.$on('focusCell', this.onFocusCell);
    }
    beforeDestroy() {
        this.model.eventBus.$off('focusCell', this.onFocusCell);
    }
    render(h) {
        const editing = this.editing;
        return h('tr', {
            class: {
                'itp-datatable__datarow': true,
                datarow: true,
                editing,
                invalid: this.invalid,
                saving: this.saving,
                deleting: this.deleting,
                expandable: this.model.rowDetailsIsExpandable,
                'shadow-sm p-3 mb-5 bg-white border rounded': editing
            },
            on: {
                keyup: (ev) => this.onKeyUp(ev)
            }
        }, this.renderCells(h));
    }
    renderCells(h) {
        const result = [];
        let autofocusHandled = false;
        for (let col of this.columns) {
            let autofocus = false;
            if (!autofocusHandled) {
                autofocus = !!col.editable && !col.readonly;
                if (autofocus) {
                    autofocusHandled = true;
                }
            }
            const n = col.systemColumn
                ? this.renderSystemColumnCell(h, col)
                : this.renderCell(h, col, autofocus);
            if (!n) {
                continue;
            }
            result.push(n);
        }
        return result;
    }
    renderSystemColumnCell(h, col) {
        const name = col.name;
        switch (name) {
            case constants.COLNAME_ROW_HEADER:
                return this.renderRowHeader(h, col);
            case constants.COLNAME_ROW_MENU:
                return this.renderRowMenu(h, col);
            case constants.COLNAME_ROW_SELECTOR:
                return this.renderRowSelector(h, col);
            default:
                return h('td', {
                    attrs: {
                        dataColumn: name
                    }
                });
        }
    }
    renderCell(h, col, autofocus = false) {
        let vs = this.validationState && this.validationState.getCellState(col.name);
        return h('ItpDataTableCell', {
            attrs: {
                dataColumn: col.name
            },
            props: {
                col: col,
                autofocus,
                row: this.row,
                value: this.row.getValue(col.field),
                noTableEdit: this.noTableEdit,
                globs: this.model.options.globs,
                messages: this.model.messages,
                editing: this.editing,
                formId: this.editing ? this.model.editorFormId : null,
                lang: this.model.lang,
                validationState: vs ? (vs.valid === false ? false : null) : null,
                validationErrorMessage: vs ? vs.errorMessage : null,
                rowState: this.validationState
            },
            scopedSlots: col.scopedSlots,
            on: {
                input: (value) => this.onCellInput(value, col)
            }
        });
    }
    onCellInput(value, col) {
        this.row.setValue(col.field, value);
    }
    onKeyUp(ev) {
        if (ev.code == 'Escape' && this.editing) {
            this.onCancelEdit();
        }
    }
    renderRowHeader(h, col) {
        return h('ItpDataTableRowRowHeader', {
            props: {
                col,
                row: this.row,
                lang: this.model.lang,
                rowExpander: this.rowDetailsToggle,
                displayRowDetails: this.row.isExpanded ||
                    this.model.options.rowDetailsMode == 'alwaysVisible'
            },
            on: {
                toggle: (value) => this.row.toggleExpanded()
            }
        });
    }
    renderRowSelector(h, col) {
        return h('ItpDataTableRowSelector', {
            props: {
                col,
                row: this.row
            }
        });
    }
    renderRowMenu(h, col) {
        return h('ItpDataTableRowMenu', {
            attrs: {
                scope: 'row',
                dataColumn: col.name
            },
            props: {
                col,
                row: this.row,
                invalid: this.invalid
            }
        });
    }
    renderEditCommands(h, col) {
        return h('ItpDataTableRowEditCommands', {
            attrs: {
                scope: 'row',
                dataColumn: col.name
            },
            props: {
                row: this.row,
                preventEdit: !this.editable,
                editing: this.editing,
                saving: this.saving,
                deleting: this.deleting,
                invalid: this.invalid,
                lang: this.model.lang,
                noDelete: this.noDelete
            },
            on: {
                beginEdit: this.onBeginEdit,
                delete: this.onDelete,
                applyEdit: this.onApplyEdit,
                cancelEdit: this.onCancelEdit
            }
        });
    }
    focusCellEditor(fieldName) {
        for (let child of this.$children) {
            if (child.$options.name == 'ItpDataTableCell') {
                const c = child;
                if (fieldName && c.col.field !== fieldName) {
                    continue;
                }
                log('focusCellEditor %s, %o', fieldName, c);
                c.focus();
                break;
            }
        }
    }
    onBeginEdit() {
        this.model.beginEdit(this.row);
    }
    onDelete() {
        this.model.deleteRow(this.row);
    }
    onApplyEdit() {
        this.model.applyEdit(this.row);
    }
    onCancelEdit() {
        this.model.cancelEdit(this.row);
    }
};
exports.ItpDataTableRow = ItpDataTableRow;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", row_model_1.RowModel)
], ItpDataTableRow.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Array)
], ItpDataTableRow.prototype, "columns", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableRow.prototype, "noTableEdit", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableRow.prototype, "editable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean, required: true }),
    __metadata("design:type", Boolean)
], ItpDataTableRow.prototype, "editing", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableRow.prototype, "noDelete", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableRow.prototype, "rowDetailsToggle", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editing'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpDataTableRow.prototype, "onEditingChanged", null);
exports.ItpDataTableRow = ItpDataTableRow = __decorate([
    (0, vue_property_decorator_1.Component)({
        components: {
            ItpDataTableCell: cell_1.ItpDataTableCell,
            ItpDataTableRowEditCommands: row_edit_commands_1.ItpDataTableRowEditCommands,
            ItpDataTableRowRowHeader: row_header_1.ItpDataTableRowRowHeader,
            ItpDataTableRowMenu: row_menu_1.ItpDataTableRowMenu,
            ItpDataTableRowSelector: row_selector_1.ItpDataTableRowSelector
        },
        inject: {
            model: 'model'
        }
    })
], ItpDataTableRow);
//# sourceMappingURL=row.js.map